import React from "react"
import L10n from "lib/carrot-l10n"
import { ButtonPrimary } from "../atoms/buttons/ButtonPrimary"
import { SupportCenterLinks } from "../../../utils/SupportCenterLinks"
import { ZendeskTextLink } from "../atoms/links/ZendeskTextLink"
import { useDispatch } from "react-redux"
import { fetchReimbursementDetails } from "../../../actions/reimbursementDetailsActions"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

// view component immediately after successfully completing carrot card activation
const ActivateSuccess = () => {
  const dispatch = useDispatch()

  const fetchUpdatedReimbursementDetails = async () => {
    await dispatch(fetchReimbursementDetails())
  }

  return (
    <div className="mw6 center tc pa3">
      <h1 className="publico-text mt0 mb4 black">{l`carrotCard.activationSuccess`}</h1>
      <p className="lh-copy mt0 mb3 black-60">{l`carrotCard.successMessage`}</p>
      <p className="lh-copy mb0 mb4">
        <ZendeskTextLink supportCenterLink={SupportCenterLinks.CARROT_CARD_SUPPORT_CENTER}>
          {l`carrotCard.howToUse`}
        </ZendeskTextLink>
      </p>
      <ButtonPrimary
        to="/transactions"
        onClick={fetchUpdatedReimbursementDetails}
      >{l`carrotCard.goToDashboard`}</ButtonPrimary>
    </div>
  )
}

export default ActivateSuccess
